/**
 * Colors
 *
 */
export default class Colors {
  static background = '#fefefe'
  static primary = '#0050b3'
  static textSecondary = '#555'
  static border = '#e6e6e6'
  static success = '#1fb275'
  static error = '#e25959'
  static warning = '#f2a036'
}
